module.exports = __webpack_public_path__ + "img/tenor.fbf97981.gif";